import { iconeDe, couleurDe, alignementDe, colonnesDe } from './apparence';

/**
 * Les bénéfices, en cartes à icône.
 *
 * ── La carte, et non la rangée ──────────────────────────────────────────────
 * Ce bloc rendait une simple rangée : icône à gauche, texte à droite, sans
 * fond ni cadre. La page d'installation d'origine pose au contraire TROIS
 * CARTES BLANCHES, icône au-dessus du titre :
 *
 *     bg-white rounded-xl p-5 shadow-sm border border-gray-100
 *
 * Sur le fond gris d'une page publique, la carte se détache ; la rangée s'y
 * fondait, et l'encadré qu'on croyait voir dans l'aperçu n'était que le cadre
 * du conteneur parent. C'est l'écart que l'administrateur voyait entre sa page
 * de la base et la page d'origine.
 *
 * ── L'icône au-dessus, dans sa pastille de couleur ──────────────────────────
 * `w-10 h-10 rounded-lg`, fond clair plein et icône soutenue — exactement ce
 * que `couleurDe` produit déjà pour les autres blocs. La page d'origine donne
 * une couleur différente à chaque carte (vert, bleu, violet) : la couleur est
 * donc réglable PAR CARTE, et non pour le bloc entier.
 */
const ArgumentsBloc = ({ bloc }) => {
    const args = Array.isArray(bloc?.arguments) ? bloc.arguments : [];
    if (args.length === 0) return null;

    const align = alignementDe(bloc.alignement);
    const colonnes = colonnesDe(bloc.colonnes, args.length);

    return (
        <section className="mb-10" data-testid="bloc-arguments">
            {bloc.titre && (
                <h2 className={`text-xl font-bold text-gray-900 mb-5 ${align.conteneur}`}>
                    {bloc.titre}
                </h2>
            )}

            {/* gap-4 — la page d'origine espace ses cartes de 4, pas de 5.
                Une gouttière plus large casse l'alignement des trois cartes
                sur la largeur d'une page de contenu. */}
            <div className={`grid gap-4 ${colonnes}`}>
                {args.map((a, i) => {
                    const Icone = iconeDe(a.icone);
                    const couleur = couleurDe(a.couleur);

                    return (
                        <div
                            key={i}
                            className={`bg-white rounded-xl p-5 shadow-sm border border-gray-100 ${align.conteneur}`}
                        >
                            {Icone && (
                                <div
                                    className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${couleur.pastille} ${align.pastille}`}
                                >
                                    <Icone className={`w-5 h-5 ${couleur.icone}`} />
                                </div>
                            )}

                            {a.titre && (
                                <h3 className="font-semibold text-gray-900 mb-1">{a.titre}</h3>
                            )}

                            {a.texte && (
                                <p className="text-sm text-gray-600">{a.texte}</p>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default ArgumentsBloc;
